var render = function render(){var _vm=this,_c=_vm._self._c;return _c('styled-tabs-container-wrap',[_c('styledTabsContainer',[(_vm.tabsList)?_c('div',{staticClass:"visible-tabs"},_vm._l((_vm.tabsList),function(tab,index){return _c('div',{key:index,class:{
          'visible-tab': true,
          'visible-tab--active': _vm.activeTab === tab.name,
        },on:{"click":function($event){return _vm._handleTabClick(tab.name, index)}}},[(tab.callback === 'return')?[_c('div',{staticClass:"return-icon"},[_c('tab-more')],1)]:_vm._e(),_vm._v(" "+_vm._s(_vm.$t(tab.name))+" ")],2)}),0):_vm._e(),_c('styled-underline',{style:(_vm.underlineStyle)})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }